module.exports = __webpack_public_path__ + "media/images/responsive/flow/resort_step_01-4d04b48384e271b72824445cd5603f30.jpg";